import {Text, TextProps} from "@mantine/core";

export type ParaProps = TextProps & { children: React.ReactNode };

export function Para(props: ParaProps) {
    const { children, ...rest } = props;
    return (<Text inherit {...rest}>{children}</Text>);
}
